<template>
  <b-row>
    <b-col cols="9">
      <client-agreements-waiting v-if="ableToViewEXABAgreementsListWaiting && waitingAgreements.length > 0"></client-agreements-waiting>
      <client-agreements-active v-if="ableToViewEXABAgreementsList"></client-agreements-active>
      <client-sla-agreements v-if="ableToViewEXCMAgreementsList"></client-sla-agreements>
      <client-cases :key="clientCasesSwitch"></client-cases>
    </b-col>
    <b-col cols="3">
      <client-notice v-if="false"></client-notice>
      <client-orders></client-orders>
      <client-documents></client-documents>
    </b-col>
    <AgreementPreviewHTMLModal :agreement-list="activeAgreements.concat(waitingAgreements)"></AgreementPreviewHTMLModal>
    <AgreementAcceptModal></AgreementAcceptModal>
    <CreateCaseModal></CreateCaseModal>
  </b-row>
</template>

<script>
import ClientAgreementsActive from '@/components/Dashboard/Views/Dashboard/client/components/ClientAgreementsActive'
import ClientCases from '@/components/Dashboard/Views/Dashboard/client/components/ClientCases'
import ClientNotice from '@/components/Dashboard/Views/Dashboard/client/components/ClientNotice'
import ClientAgreementsWaiting from '@/components/Dashboard/Views/Dashboard/client/components/ClientAgreementsWaiting'
import ClientOrders from '@/components/Dashboard/Views/Dashboard/client/components/ClientOrders'
import AgreementPreviewHTMLModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/AgreementPreviewHTMLModal'
import { mapGetters, mapActions } from 'vuex'
import AgreementAcceptModal from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/modals/AgreementAcceptModal'
import ClientDocuments from '@/components/Dashboard/Views/Dashboard/client/components/ClientDocuments'
import CreateCaseModal from '@/components/Dashboard/Views/excmcase/modals/CreateCaseModal'
import { checkPermission } from '@/utils/checkRoles'
import ClientSlaAgreements from '@/components/Dashboard/Views/Dashboard/client/components/ClientSlaAgreements'

export default {
  name: 'DashboardClient',
  components: {
    ClientSlaAgreements,
    ClientAgreementsActive,
    ClientCases,
    ClientNotice,
    ClientAgreementsWaiting,
    ClientOrders,
    AgreementPreviewHTMLModal,
    AgreementAcceptModal,
    ClientDocuments,
    CreateCaseModal
  },
  computed: {
    ableToViewEXABAgreementsList () {
      return checkPermission('exabagreements', 'EXABAgreementsList')
    },
    ableToViewEXABAgreementsListWaiting () {
      return checkPermission('exabagreements', 'EXABAgreementsListWaiting')
    },
    ableToViewEXCMAgreementsList () {
      return checkPermission('agreements', 'EXCMAgreementList')
    },
    ...mapGetters({
      activeAgreements: 'clientAgreements/getActiveAgreements',
      waitingAgreements: 'clientAgreements/getWaitingAgreements',
      accepted: 'agreements/acceptModal/getAccepted',
      createdCase: 'excmcase/create/created'
    })
  },
  data () {
    return {
      clientCasesSwitch: false
    }
  },
  watch: {
    createdCase () {
      this.clientCasesSwitch = !this.clientCasesSwitch
    },
    accepted () {
      this.fetchWaitingAgreements()
      this.fetchActiveAgreements()
    }
  },
  created () {
    this.fetchWaitingAgreements()
    this.fetchActiveAgreements()
  },
  methods: {
    ...mapActions({
      fetchWaitingAgreements: 'clientAgreements/fetchWaitingAgreements',
      fetchActiveAgreements: 'clientAgreements/fetchActiveAgreements'
    })
  }
}
</script>
